import { MainButton } from "@eventr/common-storybook";
import i18n from "i18n/i18next";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";

interface IEditButton {
  path: string;
  onClick?: () => void;
}
export const EditButton = ({ path, onClick }: IEditButton) => {
  const { pushPath } = useGlobalRouter();
  return (
    <MainButton
      id="editButton"
      icon="Edit"
      text={i18n.t("general.edit")}
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (onClick) {
          onClick();
          return;
        }
        pushPath(path);
      }}
    />
  );
};
